import SectionTitle from "@/components/ui/section-title";

export default function Tos() {
  return (
    <section className="py-24 bg-gradient-to-br from-white to-purple-50">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="Terms of Service"
        />

      <div className="text-sm text-gray-600 mb-6">
        <p>Effective Date: [Insert Date]</p>
        <p>Last Updated: [Insert Date]</p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
          <p>By accessing or using GrapeGraph.ai ("Platform"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the Platform.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">2. Description of Service</h2>
          <p>GrapeGraph.ai provides tools for users to create AI-generated characters, input scripts, and produce videos wherein these characters speak the provided content using synthesized voices and animation.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">3. User Eligibility</h2>
          <p>You must be at least 13 years old (or older if required by your local jurisdiction) to use the Platform. Users under 18 must have parental or guardian consent.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">4. User-Generated Content</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li><span className="font-medium">Ownership:</span> You retain ownership of the scripts and character designs you create.</li>
            <li><span className="font-medium">License Grant:</span> By uploading or creating content, you grant GrapeGraph.ai a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and display your content solely for the purpose of operating and improving the Platform.</li>
            <li><span className="font-medium">Responsibility:</span> You are solely responsible for all content you upload, script, or create using the Platform.</li>
            <li>
              <span className="font-medium">Restrictions:</span> You may not upload or create content that is:
              <ul className="list-disc ml-6 mt-1">
                <li>Illegal, infringing, or violates the rights of others;</li>
                <li>Pornographic, sexually explicit, or violent;</li>
                <li>Hate speech, discriminatory, or harassing;</li>
                <li>Deepfakes of real individuals without consent.</li>
              </ul>
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">5. Prohibited Uses</h2>
          <p>You agree not to:</p>
          <ul className="list-disc ml-6 space-y-1">
            <li>Misrepresent identities or impersonate others;</li>
            <li>Use the Platform to create misleading or harmful content;</li>
            <li>Interfere with the security or functionality of the Platform;</li>
            <li>Reverse engineer or scrape data from the Platform.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">6. Intellectual Property</h2>
          <p>All rights to the software, AI models, and infrastructure of GrapeGraph.ai are owned by us. Use of the Platform does not grant you any ownership rights to these materials.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">7. Payment and Subscription</h2>
          <p>If the Platform offers paid features:</p>
          <ul className="list-disc ml-6 space-y-1">
            <li>You agree to pay all fees as described at the time of purchase.</li>
            <li>Fees are non-refundable unless explicitly stated otherwise.</li>
            <li>GrapeGraph.ai may change pricing with reasonable notice.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">8. Content Moderation and Removal</h2>
          <p>We reserve the right to remove or restrict access to content that violates these Terms, and to suspend or terminate accounts in cases of serious or repeated violations.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">9. Privacy</h2>
          <p>Your use of the Platform is also governed by our Privacy Policy, which outlines how your personal information is collected, used, disclosed, and stored in compliance with Canada's Personal Information Protection and Electronic Documents Act (PIPEDA).</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">10. Termination</h2>
          <p>We may suspend or terminate your account or access at any time for any reason, including violation of these Terms. You may also delete your account at any time.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">11. Disclaimers</h2>
          <ul className="list-disc ml-6 space-y-1">
            <li>GrapeGraph.ai provides the Platform "as is" and does not guarantee the accuracy or fitness for a particular purpose.</li>
            <li>We are not liable for damages resulting from the use or inability to use the Platform.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">12. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, GrapeGraph.ai is not liable for any indirect, incidental, or consequential damages arising from your use of the Platform.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">13. Changes to Terms</h2>
          <p>We may update these Terms from time to time. Continued use of the Platform after changes are posted constitutes your acceptance of the new Terms.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">14. Governing Law</h2>
          <p>These Terms shall be governed by and construed in accordance with the laws of the Province of Ontario and the federal laws of Canada applicable therein, without regard to its conflict of law provisions. You irrevocably consent to the exclusive jurisdiction and venue of the courts in Toronto, Ontario, Canada.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">15. Language</h2>
          <p>These Terms are available in English only. Vous acceptez que cette entente soit rédigée uniquement en anglais.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">16. Contact</h2>
          <p>If you have questions about these Terms, please contact us at: <a href="mailto:support@grapegraph.ai" className="text-purple-600 hover:underline">support@grapegraph.ai</a></p>
        </section>
      </div>
    </div>
   </section>
  )
}

